module.exports = __webpack_public_path__ + "media/images/img_plan-6e7853cd3d57427fed37547283a8bc1b.png";